import React, { ChangeEventHandler, FocusEventHandler, MouseEvent } from 'react'

import {
  AlignItems,
  Box,
  Display,
  FontFamily,
  FormFieldStatus,
  InputField,
  JustifyContent,
  Link,
  LinkVariant,
  Text,
} from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { FieldContainer } from 'routes/Checkout/Components/AboutYou/FieldContainer'
import { openLoginModal } from 'routes/Checkout/checkoutActions'
import { getIsGoustoOnDemandEnabled } from 'selectors/features'

type EmailFieldProps = {
  id: string
  isTouched?: boolean
  value: string
  handleChange: ChangeEventHandler<HTMLInputElement>
  handleBlur: FocusEventHandler<HTMLInputElement>
  error?: string
}

const EmailAddressLabel = () => {
  const dispatch = useDispatch()

  const isGoustoOnDemandEnabled = useSelector(getIsGoustoOnDemandEnabled)

  const onLoginClick = (e: MouseEvent<HTMLButtonElement>) => dispatch(openLoginModal(e))

  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceBetween}
    >
      <Text fontFamily={FontFamily.Bold}>Email address</Text>
      <Box>
        <Text size={1}>
          {!isGoustoOnDemandEnabled && (
            <>
              Have an account?&nbsp;
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" size={1} variant={LinkVariant.Text} onClick={onLoginClick}>
                Log in
              </Link>
            </>
          )}
        </Text>
      </Box>
    </Box>
  )
}

export const EmailField = ({
  id,
  isTouched,
  value,
  handleChange,
  handleBlur,
  error,
}: EmailFieldProps) => (
  <FieldContainer>
    <InputField
      id={id}
      data-testing="checkoutEmailInput"
      type="email"
      label={<EmailAddressLabel />}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      status={isTouched && error ? FormFieldStatus.Error : undefined}
      validationMessage={isTouched ? error : undefined}
    />
  </FieldContainer>
)
